// src/api/productApi.ts
import { ENV } from '../../config/runtimeEnv';
import type { ProductCategory } from '../../types/inventory/ProductTypes';
import { http } from "../../lib/http/client";
const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;



// Fetch a list of products with pagination and optional search
export const fetchProductCategories = async (page: number = 1, perPage: number = 20, companyId: number, search?: string, categoryType?: 'commerce' | 'inventory'): Promise<{ data: ProductCategory[]; total: number }> => {
	const response = await http.get(`${API_BASE_URL}/product-categories`, {
		params: {
			page,
			per_page: perPage,
			companyId,
			...(search ? { search } : {}),
			...(categoryType ? { category_type: categoryType } : {}),
		},
	});
	return {
		data: response.data.data,
		total: response.data.total,
	};
};



// Fetch details of a specific product category
export const fetchProductCategory = async (category_id: number): Promise<ProductCategory> => {
	const response = await http.get(`${API_BASE_URL}/product-categories/${category_id}`);
	return response.data;
};



// Create a new product category
export const createProductCategory = async (productCategoryData: Partial<ProductCategory>): Promise<ProductCategory> => {
	const response = await http.post(`${API_BASE_URL}/product-categories`,
		{
			...productCategoryData,
		}
	);
	return response.data;
};

// Update an existing product category
export const updateProductCategory = async (category_id: number, productCategoryData: Partial<ProductCategory>): Promise<ProductCategory> => {
	const response = await http.put(
		`${API_BASE_URL}/product-categories/${category_id}`,
		{
			...productCategoryData,
		}
	);
	return response.data;
};

// Delete a product category
export const deleteProductCategory = async (category_id: number): Promise<void> => {
	await http.delete(`${API_BASE_URL}/product-categories/${category_id}`);
};











